import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Customer } from 'src/app/model/customer.model';
import { ApiService } from 'src/app/services/api.service';
import { Bill } from 'src/app/model/bill.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-newbill',
  templateUrl: './newbill.component.html',
  styleUrls: ['./newbill.component.scss']
})
export class NewbillComponent implements OnInit {
  
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource = new MatTableDataSource<Bill>(null);
  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public custData: Customer,
    private apiService: ApiService
    ) {
      
     }

  ngOnInit(): void {
    this.setBillDetails();
  }
  billData: Bill = new Bill;
  setBillDetails() {
      this.billData.billUnitRate = 2 ;
      this.billData.previousReading = 3;
    
  }
  setBillAmount(){
    this.billData.billAmount = (this.billData.currentReading - this.billData.previousReading ) * this.billData.billUnitRate;
  }

}
